import type { RouteObject } from 'react-router';

import type { Role } from '@shared/session';
import { RouteErrorBoundary } from '@shared/ui/error-boundary';

import { RootLayout } from '../layouts/root.layout';
import { RouteLoading } from '../layouts/route-loading.ui';
import { RouteGuard } from './route-guard.ui';
import { serviceNotFoundRoute, servicePublicRoutes, serviceRoleRoutes } from './service.routes';

export interface CreateRoutesOptions {
  /** 활성 역할. 게스트면 null */
  role: Role | null;
}

/** 공개 라우트 + (가드 아래) 그 역할의 트리. 다른 역할의 트리는 마운트하지 않는다 */
function serviceTree(role: Role | null): RouteObject[] {
  return [
    ...servicePublicRoutes,
    {
      Component: RouteGuard,
      children: [
        ...(role ? serviceRoleRoutes[role] : []),
        // 게스트는 가드가 로그인으로 보내고, 로그인한 사용자는 "없는 화면"을 본다.
        serviceNotFoundRoute,
      ],
    },
  ];
}

/** 서비스 라우트 트리: 공개 라우트 + 역할별 트리 */
export function createRoutes({ role }: CreateRoutesOptions): RouteObject[] {
  return [
    {
      Component: RootLayout,
      ErrorBoundary: RouteErrorBoundary,
      // 첫 주소의 lazy 라우트 모듈을 불러오는 동안 보인다.
      HydrateFallback: RouteLoading,
      children: serviceTree(role),
    },
  ];
}
